(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mt-combo-product"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-mt-pair]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var text = JSON.parse(root.querySelector('[data-pair-texts]').textContent);
  var form = root.querySelector('[data-pair-form]');
  var status = root.querySelector('[data-pair-status]');
  var button = root.querySelector('[data-pair-add]');
  var total = root.querySelector('[data-pair-total]');
  var base = root.dataset.root || '/';
  var params = new URLSearchParams(location.search);
  var shoeHandle = params.get('shoe');
  var title = params.get('combo_title');
  var choices = {};
  var busy = false;
  if (title) root.querySelector('[data-pair-title]').textContent = title.slice(0,150);
  function norm(value) { return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLowerCase(); }
  function variantOptions(variant) { return variant.options || [variant.option1,variant.option2,variant.option3].filter(function (x) {return x != null;}); }
  function personalIndexes(product) { return product.options.map(function (o,i) {return /personaliz|customiz/.test(norm(typeof o === 'string' ? o : o.name)) ? i : -1;}).filter(function (i) {return i >= 0;}); }
  function allowed(variant,indexes) { var opts = variantOptions(variant); return indexes.every(function(i) {return /^(nao|sem personalizacao|sem personalizar|no|none)$/.test(norm(opts[i]));}); }
  function money(value) { return new Intl.NumberFormat('pt-BR',{style:'currency',currency:root.dataset.currency || 'BRL'}).format(value/100); }
  function selected(key) { var select=root.querySelector('[data-pair-select="'+key+'"]'); return choices[key].find(function(v) {return String(v.id)===select.value && v.available;}); }
  function update() {
    var shirt=selected('shirt'),shoe=selected('shoe');
    button.disabled=busy || !shirt || !shoe;
    total.textContent=shirt && shoe ? money(shirt.price+shoe.price) : '—';
  }
  function populate(product,key) {
    var box=root.querySelector('[data-pair-product="'+key+'"]');
    box.querySelector('[data-pair-name]').textContent=product.title;
    var image=box.querySelector('[data-pair-image]');
    if(product.featured_image){image.src=product.featured_image;image.alt=product.title;}else{image.hidden=true;}
    var indexes=key==='shirt' ? personalIndexes(product) : [];
    choices[key]=product.variants.filter(function(v){return key!=='shirt' || allowed(v,indexes);});
    var select=box.querySelector('select');
    select.add(new Option(text.select,''));
    choices[key].forEach(function(v){
      var label=variantOptions(v).filter(function(_,i){return indexes.indexOf(i)<0;}).join(' / ');
      var option=new Option(label+(v.available?'':' — '+text.sold_out),String(v.id));
      option.disabled=!v.available;select.add(option);
    });
    if(!choices[key].some(function(v){return v.available;})){select.disabled=true;status.textContent=text.no_variants;}
    select.addEventListener('change',update);
  }
  async function getProduct(handle) {
    var response=await fetch(base+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'});
    if(!response.ok)throw new Error('load');
    var product=await response.json();
    if(!Array.isArray(product.variants)||!Array.isArray(product.options))throw new Error('product');
    return product;
  }
  async function init() {
    try {
      if(!shoeHandle || !/^[a-z0-9-]+$/.test(shoeHandle))throw new Error('handle');
      var products=await Promise.all([getProduct(root.dataset.shirt),getProduct(shoeHandle)]);
      status.textContent='';populate(products[0],'shirt');populate(products[1],'shoe');form.hidden=false;update();
    }catch(error){status.textContent=text.error;}
  }
  form.addEventListener('submit',async function(event){
    event.preventDefault();
    if(busy)return;
    var shirt=selected('shirt'),shoe=selected('shoe');
    if(!shirt||!shoe){status.textContent=text.choose_error;return;}
    busy=true;button.disabled=true;button.textContent=text.adding;form.setAttribute('aria-busy','true');status.textContent='';
    try {
      try{sessionStorage.removeItem('mt_combo_flow_v1');sessionStorage.removeItem('mt_combo_flow_pending_v1');}catch(error){}
      var response=await fetch(base+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:[{id:shirt.id,quantity:1},{id:shoe.id,quantity:1}]})});
      if(!response.ok){var failure=await response.json();throw new Error(typeof failure.description==='string'?failure.description:text.add_error);}
      status.textContent=text.success;
      location.assign(base+'discount/COMBOEMCAMPO30?redirect='+encodeURIComponent(base+'cart?combo=combo-em-campo&combo_flow=done'));
    }catch(error){status.textContent=error.message && error.message!=='Failed to fetch'?error.message:text.add_error;busy=false;button.textContent=text.add;form.removeAttribute('aria-busy');update();}
  });
  init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-promotion-countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mt-promotion-countdown')) {
  customElements.define('mt-promotion-countdown', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      const datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}-03:00$/;
      const startValue = this.dataset.start || '';
      const endValue = this.dataset.end || '';
      const start = datePattern.test(startValue) ? Date.parse(startValue) : NaN;
      const end = datePattern.test(endValue) ? Date.parse(endValue) : NaN;
      const valid = Number.isFinite(start) && Number.isFinite(end) && end > start;
      const enabled = this.dataset.enabled === 'true';
      const editor = this.dataset.editor === 'true';
      const notice = this.querySelector('[data-notice]');
      const fields = ['days','hours','minutes','seconds'].map(key => this.querySelector('[data-' + key + ']'));
      const tick = () => {
        const now = Date.now();
        const active = enabled && valid && now >= start && now < end;
        this.hidden = !active && !editor;
        if (notice) {
          notice.hidden = active;
          notice.textContent = !enabled ? 'Prévia do editor: promoção desativada.' :
            !valid ? 'Defina início e fim válidos nas configurações. Nada será exibido na loja sem essas datas.' :
            now < start ? 'Prévia do editor: promoção agendada, ainda não começou.' :
            'Prévia do editor: promoção encerrada e oculta na loja.';
        }
        const remaining = active ? Math.max(0, Math.floor((end - now) / 1000)) : 0;
        const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
        fields.forEach((field, index) => { if (field) field.textContent = String(values[index]).padStart(2, '0'); });
        if (!enabled || !valid || now >= end) this.stop();
      };
      this.interval = setInterval(tick, 1000);
      tick();
    }
    stop() { if (this.interval) { clearInterval(this.interval); this.interval = null; } }
    disconnectedCallback() { this.stop(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
